import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { Observable } from 'rxjs/Observable';
import { RequestSaveDistributionDto } from '../dto/bank-distribution-sf6.dto';

@Injectable()
export class BankDistributionSf6Api {

  module: string = '';
  model: string = 'sf6s/bankDistribution';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello Emp Performance SF6 Provider');
  }

  listing(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "listing";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  viewEdit(formData) {
    const method: string = "GET";
    const model: string = this.model;
    const func: string = "viewedit";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }
  
  save(payload: RequestSaveDistributionDto): Observable<any> {
		const method: string = 'POST';
		const func: string = 'save';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApi.urlBuilder(method, this.model, func, {}, urlParams, this.module);
		return this.nestApi.request(method, url, params, urlParams, body);
	}
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/bank-distribution-sf6.api.ts